import { useMutation } from 'glimmer-apollo'
import { parse, print } from 'graphql'
import { QUOTE_FRAGMENT } from 'customer-flows/gql/fragments/quote'

export function createQuote(
  context: Object,
  variables: QuoteStrictInput
): Promise<CreateQuoteResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const createQuoteMutation = useMutation<CreateQuoteResponse, CreateQuoteInput>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(error)
        },
        onComplete: (data: CreateQuoteResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    createQuoteMutation.mutate({
      input: {
        quoteInput: variables
      }
    })
  })
}

// Exported so the composed document can be asserted in tests — the QuoteFragment
// definition must be interpolated into the mutation (regression DEV-8648: a missing
// fragment definition caused CreateQuote to fail with "Unknown fragment QuoteFragment").
export const mutation = parse(`
  mutation CreateQuote($input: CreateQuoteV2Input!) {
    createQuoteV2(input: $input) {
      quote {
        ...QuoteFragment
      }
      errors {
        code
        detail
        value
      }
      warnings {
        message
      }
    }
  }
  ${print(QUOTE_FRAGMENT)}
`)
